import { View2DSetting } from "./View2DSettings";

export class EditorSettings {

    public view2D: View2DSetting;

    constructor() {
        this.view2D = new View2DSetting();
    }
}

export const defaultEditorSettings = new EditorSettings();